;(function ($) {

  var searchToggleButton = $('#z_search_toggle'),
    searchformHeader = $('#z_searchform_header'),
    searchField = $('#z_searchform_header_field'),
    slickSlider = $('#masthead_slider');

  $(document).ready(function () {

    $('body').on('click', '#z_search_toggle', searchToggle);
    $('body').on('blur', '#z_searchform_header_field', blurSearchToggle);
    $('body').on('blur', '#z_searchform_header_submit', blurSearchToggle);

    $('body').on('click', '#dismissable_alert_close', dismissAlert);
    init_alert();

    // NOT YET USED
    //$( 'body' ).on( 'click', 'ul.page-list span.arrow', toggleSubPages );

    // Share Popups
    $('body').on('click', '.social-share', social_share_popup);


  });


  /**
   * Toggles the search bar in the header and then focuses in the search bar once it appears.
   *
   * @param {object} e
   * @returns {void}
   */
  function searchToggle() {
    console.log('searchToggle');

    if (searchformHeader.hasClass('open')) {
      searchToggleButton.removeClass('open');
      searchformHeader.removeClass('open');
      searchformHeader.attr('aria-hidden', true);
    } else {
      searchformHeader.addClass('open');
      searchToggleButton.addClass('open');
      searchformHeader.attr('aria-hidden', false);
      searchField.focus();
    }

  }

  /**
   * Closes the header search bar when losing focus on it, via tabbing or clicking away.
   *
   * @param {object} e
   * @returns {void}
   */
  function blurSearchToggle(e) {

    // console.log(e);
    if (e.relatedTarget !== null) {
      if ((e.relatedTarget.id === 'z_searchform_header_field') || (e.relatedTarget.id === 'z_searchform_header_submit')) {
        return;
      } else {
        hideSearchPopupForm();
      }
    } else {
      hideSearchPopupForm();
    }
  }

  function hideSearchPopupForm() {
    if (searchformHeader.hasClass('open')) {
      searchToggleButton.removeClass('open');
      searchformHeader.removeClass('open');
      searchformHeader.attr('aria-hidden', true);
      searchToggleButton.focus();
    }
  }

  /**
   * Init the Slider(s) if any are on page.
   */
  function initSlickSlider() {
    // console.log('initSlickSlider');
    if (slickSlider) {

      $('#masthead_slider').slick({
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        infinite: true,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        accessibility: true,
        speed: 1200,
        fade: true,
        cssEase: 'linear'
      });
    }

  }

  /**
   * Init the Slider(s) if any are on page.
   */
  function initSlickSliderDots() {

    if (slickSlider) {

      $('#masthead_slider').slick({
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        infinite: true,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        accessibility: true,
        speed: 1200,
        fade: true,
        cssEase: 'linear',
        dots: true
      });
    }

  }

  /**
   * Dismisses the Alert and adds a cookie to keep alert suppressed for a day by use of cookies.
   */
  function dismissAlert() {
    let $this = $(this),
      alertContainer = $('#dismissable_alert'),
      headerContainer = $('#site_header');

    if (alertContainer.length) {
      alertContainer.hide();
    }

    Cookies.set('PV_Alert_Dismissal', 1, {expires: 1});
    if (headerContainer.hasClass('has-alert')) {
      headerContainer.removeClass('has-alert');
    }

    // console.log('dismissAlert');
  }

  /**
   * Show alert is no cookie is set
   */
  function init_alert() {
    // console.log('init_alert', Cookies.get('PV_Alert_Dismissal'));
    if (!Cookies.get('PV_Alert_Dismissal')) {
      let alertContainer = $('#dismissable_alert')
      alertContainer.addClass('show');
    }
  }

  /**
   * Toggles the sub pages in the sidebar
   *
   * @param {object} e
   * @returns {void}
   */
  function toggleSubPages(e) {
    e.preventDefault();
    //console.log( 'submenu toggled' );
    var $this = $(this),
      children = $this.parent('a').siblings('.children');

    if ($this.hasClass('open')) {
      children.slideUp(300, function () {
        $this.removeClass('open');
        children.removeClass('open');
      });
    } else {
      children.slideDown(300, function () {
        $this.addClass('open');
        children.addClass('open');
      });
    }
  }

  // $(window).load(function () {
  //   if (Foundation.MediaQuery.atLeast('medium')) {
  //
  //   }
  // });


  /**
   * Gets the popup windows ready depending on share platform, sets up the width/height.
   *
   * @param e
   * @returns {boolean}
   */
  function social_share_popup(e) {
    e.preventDefault();

    let $this = $(this),
      url = $this.attr('href'),
      windowName = 'facebookShareWindow',
      width = 550,
      height = 450;

    if ($this.data('share') === 'twitter') {
      windowName = 'twitterShareWindow';
      height = 260;
    }
    if ($this.data('share') === 'linkedIn') {
      windowName = 'linkedInShareWindow';
      height = 260;
    }
    popup_center(url, windowName, width, height);

    return false;
  }


  /**
   * PopupCenter - opens a popup window in the middle, works with multiple monitors.
   *
   * @param {string} url - full url
   * @param {string} title - window title (use this to manipulate window after its created)
   * @param {int} w - width of window
   * @param {int} h - height of window
   * @returns {void}
   */
  function popup_center(url, title, w, h) {
    // Fixes dual-screen position                         Most browsers      Firefox
    let dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    let dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

    let width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    let height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    let left = ((width / 2) - (w / 2)) + dualScreenLeft;
    let top = ((height / 2) - (h / 2)) + dualScreenTop;
    let newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (window.focus) {
      newWindow.focus();
    }
  }

  // $(window).on('changed.zf.mediaquery', function (event, name) {
  //   console.log('Breakpoint Watch: ', name);
  // });

})(jQuery);
